import React from "react";
import { CondimentInterface } from "./Condiment";
import { OperationalCountryInterface } from "./OperationalCountry";

export enum MEDIA_QUERY {
  MONITOR = "1440px",
  LAPTOP = "1200px",
  TABLET_HORIZONTAL = "992px",
  TABLET_VERTICAL = "768px",
  MOBILE = "480px",
}

export enum ERROR_REASON_CODE {
  INCOMPATIBLE_SPICE_COMBINATION = "INCOMPATIBLE_SPICE_COMBINATION",
}

export interface CommonResponseInterface<T> {
  lastPage: false;
  data: T[];
  count: number;
}

export interface SkeletonComponentProps {
  children: React.ReactNode;
  skeleton: React.ReactNode;
  isLoading: boolean;
}

export interface WeightRangeMixInterface {
  maxVolumeOfMix: number;
  minVolumeOfMix: number;
}

export interface ComputedPricesProps {
  condiments: CondimentInterface[];
  markup: number;
  discount: number;
  priceForPackaging: number;
  vat: number;
  selectedWeight: number;
}

export interface ComputedPricesResponse {
  priceWithoutVatPerCup: number;
  priceWithoutVatWithMarkup: number;
  priceWithVatPerCup: number;
  priceWithVatAndDiscount: number;
  priceForOneHundredGrams: number;
  totalPrice: number;
  discountValue: number;
}

export interface CalculatedCondimentsInterface {
  name: string;
  quantity: number;
  price: number;
}

export interface CustomErrorInterface {
  reasonCode: ERROR_REASON_CODE;
  title?: string;
  description?: string;
}

export interface RouterErrorInterface {
  data: string;
  internal: boolean;
  status: number;
  statusText: string;
}

export interface FormatCurrencyInterface {
  amount: number;
  country: OperationalCountryInterface | undefined;
  amountLabel?: string | null;
}
